import { tealiumLog } from "Services/TealiumHelpers";
import { FARECACHE_NAVITAIRE_SETTINGS_PATH } from "Services/constants";
import { ApiStationSettings } from "Shared/models/ApiStationSettings";
import { ApiNavitaireSettings } from "Shared/models/ApiNavitaireSettings";
import { removeTrailingSlash } from "Services/common";
import { ApiCultureSettings } from "ComponentModels/ApiCultureSettings";
import { createHeaders } from "./HeaderHelper";
import { useReduxState } from "Shared/redux/useReduxState";

export interface NavitaireSettings {
	abTestSettings: AbTestSettings;
	cultureSettings: ApiCultureSettings;
	currency: string;
	stationSettings: ApiStationSettings;
}

export const useNavitaireSettings = () => {
	const [_navitaireSettings, setNavitaireSettings] = useReduxState("navitaireSettings");

	const fetchNavitaireSettings = async () => {
		const headers = createHeaders();

		const baseUrl = removeTrailingSlash(window.JetSmart.NavitaireSettingsOptions.BaseAddress);
		const url = `${baseUrl}${FARECACHE_NAVITAIRE_SETTINGS_PATH}`;
		const response = await fetch(url, { headers });

		if (response.ok) {
			const responseJson = (await response.json()) as ApiNavitaireSettings;
			return responseJson;
		} else {
			tealiumLog({
				eventName: "server_error",
				eventParams: {
					page: "/",
					error_code: response.status,
					message: response.statusText,
					server_url: url,
				},
				udoParams: {
					error_info: response.statusText,
					error_code: response.status,
				},
			});

			throw new Error("Network response was not ok.");
		}
	};

	const fetchDirectFareCache = async (culture: string) => {
		const result = await fetchNavitaireSettings();

		return {
			abTestSettings: result.AbTestSettings,
			cultureSettings: result.CultureSettings,
			currency: result.DefaultCurrencies.find((c) => c.Culture === culture)?.Currency,
			stationSettings: result.StationSettings,
		};
	};

	const init = async (data: { culture: string; loadedValues: NavitaireSettings }) => {
		const value = await (window.JetSmart.NavitaireSettingsOptions.Mode === "DirectFareCache"
			? fetchDirectFareCache(data.culture)
			: Promise.resolve(data.loadedValues));

		setNavitaireSettings(value);
	};

	return { init };
};
